import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import { constants } from '../../../../../../../Helpers/Constants';
import {Modal} from 'react-router-modal';
import EmptyState from '../../../../../../Common/EmptyState.jsx';
import { Trans } from 'react-i18next';
import OL_Expense from '../../../../Expenses/OL_Expense';
import Icon from '../../../../../../Common/DesignSystem/Icons/Icon';
import Button from '../../../../../../Common/DesignSystem/Button';
import { LoadingIconRow } from '../../../../../../Common/Loading_Icon';
import colours from '../../../../../../Common/DesignSystem/Colours';
import ReactTooltip from 'react-tooltip';

const VehicleExpensesTab = (props) => {
    const [addExpense, setAddExpense] = useState(constants.add_expense_mode.hidden);
    const [expenses, setExpenses] = useState([]);
    const [source, setSource] = useState(null);
    const [expenseId, setExpenseId] = useState(null);
    const [sortFilter, setSortFilter] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setSource(retrieveExpenseData());

        return () => {
            source?.cancel();
        }
    }, []);

    const onClickView = (id) => {
        setAddExpense(constants.add_expense_mode.edit);
        setExpenseId(id);
    }

    const getExpenseCategories = (expense) => {
        if (expense.categories && expense.categories.length >= 1) {
            return (
                <div>
                    {expense.categories.map((category, index) => (
                        <span>{category.category.Name + (index < expense.categories.length - 1 ? ", " : "")}</span>
                    ))}
                </div>
            )
        }
        return "None";
    }

    const addSortClasses = (name) => {
        if (sortFilter === name) {
            if (sortDirection === "asc") {
                return " fa-sort-up primary"
            } else if (sortDirection === "desc"){
                return " fa-sort-down primary"
            }
        } else {
            return " fa-sort"
        }
    }

    const updateSorting = (name) => {
        if (sortFilter !== name) {
            applyFilters(name, "asc");
        } else {
            if (sortDirection === "desc") {
                applyFilters(sortFilter, "asc");
            } else if (sortDirection === "asc") {
                applyFilters(null, null);
            } else {
                applyFilters(name, "asc");
            }
        }
    }

    const applyFilters = (sort_filter, sort_direction) => {
        setLoading(true);
        setSortFilter(sort_filter);
        setSortDirection(sort_direction);

        axios.get('/ajax/expenses?search_term=' + props.vehicle.vin, {
            params: {
              sort_filter,
              sort_direction,
            }})
        .then(function(response) {
            setExpenses(response?.data.data.data);
            setLoading(false);
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data?.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data?.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    const closeAddExpense = () => {
        setAddExpense(constants.add_expense_mode.hidden);
        setExpenseId(null);
    }

    const renderAddExpense = () => {
        if (addExpense !== 0) {
            return (
                <Modal inClassName="overview_view w-50">
                    <OL_Expense mode={addExpense} closeOverlay={closeAddExpense} vehicle_details={props.vehicle_details} refresh={retrieveExpenseData} v_id={props.vehicle.V_ID} expense_id={expenseId} editCallback={() => setAddExpense(constants.add_expense_mode.edit)} />
                </Modal> 
            )
        } else {
            return null;
        }
    }

    const retrieveExpenseData = () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        axios.get('/ajax/expenses?search_term=' + props.vehicle.vin, {
            cancelToken: source.token
        })
        .then(function (response) {
            setExpenses(response?.data.data.data);

            ReactTooltip.rebuild();
        })
        .catch((err) => {
            showStatusMsg("Couldn't retrieve expenses")
        })
        .finally(() => {
            setLoading(false);
        });

        return source;
    }

    const renderAttachments = (expense) => {
        if (expense.attachments && expense.attachments.length >= 1) {
            return <div>
                {expense.attachments.map(attachment => (
                    attachment.Active === 1 ? 
                    <div>
                        <span onClick={()=> {window.open('' + attachment.URL)}} className="link" style={{fontSize: 14, cursor: 'pointer'}}>
                            {attachment.Name?.split('_')[3].length > 10 ? attachment.Name?.split('_')[3].slice(0,10) + '...' : attachment.Name?.split('_')[3]}
                        </span>
                    </div> : null
                ))}
            </div>
        }
        return "None";
    }

    const renderTable = () => {
        if (!expenses.length) {
            return(
                <tbody>
                    <tr>
                        <td colSpan = '10'><EmptyState image="dollar-symbol.svg" text="No Expenses" /></td>
                    </tr>
                </tbody>
            )
        } else {
            return(
                expenses.map((expense, index) => {
                    return (
                        <tbody className="ds-booking-row" key={expense.ID}>
                            <tr className="ds-booking-row no-border" style={{backgroundColor: index % 2 !== 0 ? '#F4F6F8' : 'white'}} onClick={()=>{onClickView(expense.ID, expense.V_ID)}}>
                                <td label="Date" className="align-left" rowSpan={(expense.line_items.length) + ""} style={{paddingLeft: 20}}>
                                    <Trans>{moment(expense.Date).format('MMM DD, YYYY')}</Trans>
                                </td>
                                <td rowSpan={(expense.line_items.length) + ""} label="Merchant" className="align-left">
                                    {expense.Merchant}
                                </td>
                                <td label="Item" className="align-center">
                                    1 / {expense.line_items.length}
                                </td>
                                <td label="Category" className="align-left">
                                    {expense.line_items[0].category.Name}
                                </td >
                                <td label="Description" className="align-left" style={{maxWidth: '400px', width: '250px', minWidth: '100px', overflowX: 'auto'}}>
                                    {expense.line_items[0].Description ? expense.line_items[0].Description : 'None'}
                                </td>
                                <td label="Net Cost" className="align-right">
                                    ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(expense.line_items[0].Net_Cost)}
                                </td>
                                <td label="Tax" className="align-right">
                                    ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(expense.line_items[0].Tax)}
                                </td>
                                <td label="Total Cost" className="align-right" style={{paddingRight: 20}}>
                                    ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(expense.line_items[0].Total_Cost)}
                                </td>
                                <td rowSpan={(expense.line_items.length) + ""} label="Link" className="align-center">
                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                    {
                                        expense.linked_booking ?
                                            <div 
                                                data-multiline 
                                                data-tip={"Release: " + moment(expense.linked_booking.Start_Date + ' ' + expense.linked_booking.Release_Time).format('MMM DD, YYYY - h:mm A') + "<br/>"
                                                            + "Return: " + moment(expense.linked_booking.End_Date + ' ' + expense.linked_booking.Return_Time).format('MMM DD, YYYY - h:mm A')} 
                                                style={{marginLeft: 2, marginRight: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                                    <Icon name="Booking" size={24} style={{borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}}/>
                                            </div> : null
                                    }
                                    {
                                        expense.Linked_User ?
                                        <div 
                                            data-multiline 
                                            data-tip={expense.linked_booking.profile.First_Name + ' ' + expense.linked_booking.profile.Last_Name + "<br/>"
                                                        + (expense.linked_booking.profile.Title ? expense.linked_booking.profile.Title + " at " + expense.linked_booking.profile.Company : null)} 
                                            style={{marginLeft: 2, marginRight: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                                <Icon name="User" size={24} style={{borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue}}/>
                                        </div> : null
                                    }
                                    </div>
                                </td> 
                                <td rowSpan={(expense.line_items.length) + ""} label="Actions" className="align-center">
                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                                        <Icon name="Edit" size={24} style={{marginLeft: 2, marginRight: 2, color: colours.primary.blue}}/>
                                        {/* <Icon name="Trash" size={24} style={{marginLeft: 2, marginRight: 2, color: colours.accent.error_red}}/> */}
                                    </div>
                                </td>
                            </tr>
                            {
                                expense.line_items.length > 1 ?
                                    expense.line_items.map((item, item_index) => {
                                        if (item_index !== 0) {
                                            return (
                                                <tr className="ds-booking-row no-border" key={expense.ID + "_" + item.ID} style={{backgroundColor: index % 2 !== 0 ? '#F4F6F8' : 'white'}} onClick={()=>{onClickView(expense.ID, expense.V_ID)}}>
                                                    <td label="Item" className="align-center">
                                                        {item_index + 1} / {expense.line_items.length}
                                                    </td>
                                                    <td label="Category" className="align-left">
                                                        {item.category.Name}
                                                    </td >
                                                    <td label="Description" className="align-left" style={{maxWidth: '400px', width: '250px', minWidth: '100px', overflowX: 'auto'}}>
                                                        {item.Description ? item.Description : 'None'}
                                                    </td>
                                                    <td label="Net Cost" className="align-right">
                                                        ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Net_Cost)}
                                                    </td>
                                                    <td label="Tax" className="align-right">
                                                        ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Tax)}
                                                    </td>
                                                    <td label="Total Cost" className="align-right" style={{paddingRight: 20}}>
                                                        ${new Intl.NumberFormat('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(item.Total_Cost)}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })
                                : null
                            }
                        </tbody>
                    )
                })
            )
        }
    }

    return(
        <div>
            <div className="row expanded bkg-white-dark">
                <div className="columns large-12 medium-12 small-12" style={{padding: '0px'}}>
                    <div className="ds-card">
                        <div style={{paddingBottom: 8}}>
                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
                                <Button primary leading_ic="Expenses" label="Add Expense" onClick={() => setAddExpense(constants.add_expense_mode.add)}/>
                            </div>
                        </div>
                        <div>
                            <table className = "ds-table">
                                <thead>
                                    <tr className = "table-header">
                                        <th style = {{paddingLeft: 20, width: "200px"}} className={sortFilter === 'date' ? "align-left is-sorted" : "align-left"} onClick={() => {updateSorting("date")}}>
                                            <Trans>Date</Trans>
                                            <i className = {"sort-icon fas black-lightest" + (addSortClasses("date"))}></i>
                                        </th>
                                        <th className={sortFilter === 'merchant' ? "align-left is-sorted" : "align-left"} onClick={() => {updateSorting("merchant")}}>
                                            <Trans>Merchant</Trans>
                                            <i className = {"sort-icon fas black-lightest" + (addSortClasses("merchant"))}></i>
                                        </th>
                                        <th className="align-center"><Trans>Item</Trans></th>
                                        <th className="align-left"><Trans>Category</Trans></th>
                                        <th className="align-left"><Trans>Description</Trans></th>
                                        <th className={sortFilter === 'net_cost' ? "align-right is-sorted" : "align-right"} onClick={() => {updateSorting("net_cost")}}>
                                            <Trans>Net Cost</Trans>
                                            <i className = {"sort-icon fas black-lightest" + (addSortClasses("net_cost"))}></i>
                                        </th>
                                        <th className={sortFilter === 'tax' ? "align-right is-sorted" : "align-right"} onClick={() => {updateSorting("tax")}}>
                                            <Trans>Tax</Trans>
                                            <i className = {"sort-icon fas black-lightest" + (addSortClasses("tax"))}></i>
                                        </th>
                                        <th className={sortFilter === 'total_cost' ? "align-right is-sorted" : "align-right"} onClick={() => {updateSorting("total_cost")}}>
                                            <Trans>Total Cost</Trans>
                                            <i className = {"sort-icon fas black-lightest" + (addSortClasses("total_cost"))}></i>
                                        </th>
                                        <th className="align-center">
                                            <Trans>Link</Trans>
                                        </th>
                                        <th style={{paddingRight: 20}} className="align-center">
                                            <Trans>Actions</Trans>
                                        </th>
                                    </tr>
                                </thead>
                                {loading ? (
                                    <tbody>
                                        {LoadingIconRow(10)}
                                    </tbody>
                                ) : (
                                    renderTable()
                                )}
                            </table>
                            <div className = "clearfix"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {renderAddExpense()}
            </div>
        </div>
    )
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(VehicleExpensesTab)